<template>
  <div>
    <shop-pageframe :option="option" :hide-modules="hideModules">
      <div class="view-page">
        <div class="p-wrap">
          <div class="p-main p-clear">
            <div class="p-content">
              <p class="curr_position">
                {{ $t('w40') }} > {{ $t('w41') }} >
                <a href="/">{{ $t('w42') }}</a>
              </p>
              <router-view/>
            </div>
          </div>
        </div>
      </div>
    </shop-pageframe>
  </div>
</template>

<script>
// import {languages} from "@/locale/district";
// import langMap from "@/locale/langMap";
import i18n from "@/locale/i18n"
import { setLocaleUrl } from "@/locale/utils"
import { isInJm } from '../utils/jm_util'
export default {
  name: "home",
  data() {
    return {
      option: {
        appName: 'quanyi.shop.jd.com',
        topMenuId: 301,
        systemId: 3,
        sideMenuId: 14,
        logo: {
          src: '//static.360buyimg.com/shop/pop_shop_uibase1.0.0/widget/crm-header/images/crm-logo.png',
          href: '//quanyi.shop.jd.com/'
        },
        showUserInfo: true,
        defaultAllSelected: true
      },
      // 设置不展示哪些模块，如 'header'、'navigation'、'sidebar'、'widget'、'footer' 分别为 顶部条、菜单导航、左侧菜单、右侧挂件、底部信息，比如不展示左侧菜单：['sidebar']
    }
  },
  computed: {
    langs() {
      return {
        default: i18n.locale,
        languageList: []
        //  languages.map(item => {
        //   return {
        //     key: item,
        //     name: langMap[item]
        //   };
        // })
      };
    },
    hideModules() {
      if (isInJm()) {
        return ['header', 'navigation', 'sidebar', 'widget', 'footer']
      }
      return []
    }
  },
  methods:{
    changeLang(lang){
      setLocaleUrl(lang);
    }
  }
};
</script>


